module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-miguel-a-padrinan-c779b0dbc1a9aa952116c1d939d9ec94.jpg";